<template>
  <div>
    <v-radio-group
      v-model="selectedMaxPointValue"
      hide-details
      row>
      <v-radio
        v-for="(option, index) in options"
        :key="index"
        :label="option.text"
        :value="option.value"
        color="secondary"
      ></v-radio>
    </v-radio-group>
    <v-text-field
      v-if="selectedMaxPointValue === 3"
      class="allotaion-area mt-3"
      v-model="selectedMaxPoint"
      label="その他"
      outlined
      :rules="rules"
      color="secondary"
      dense
    />
  </div>
</template>

<script>
export default {
  data: () => ({
    options: [
      {text: '100点満点', value: 1, maxPoint: '100'},
      {text: '50点満点', value: 2, maxPoint: '50'},
      {text: 'その他', value: 3, maxPoint: ''},
    ],
    rules: [
      value => !value.match(/[^0-9]/) || '数字のみで入力してください',
    ],
  }),

  methods: {
    // 全角数字を半角へ変換
    convertHalf(text) {
      return text.replace(/[０-９]/g, (s) => {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
      });
    },
  },

  watch: {
    selectedMaxPointValue(now) {
      if (now === 3) {
        this.$store.commit('setSelectedMaxPoint', { selectedMaxPoint: '' })
        return
      }
      const maxPoint = this.options.find(option => option.value === now).maxPoint
      this.$store.commit('setSelectedMaxPoint', { selectedMaxPoint: maxPoint })
    }
  },

  computed: {
    selectedMaxPointValue: {
      get() {
        return this.$store.state.top.selectedMaxPointValue;
      },
      set(value) {
        this.$store.commit('setSelectedMaxPointValue', { selectedMaxPointValue: value })
      }
    },

    selectedMaxPoint: {
      get() {
        return this.$store.state.top.selectedMaxPoint;
      },
      set(value) {
        this.$store.commit('setSelectedMaxPoint', { selectedMaxPoint: this.convertHalf(value) })
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
  .allotaion-area
    width 200px
</style>>
